import { render, staticRenderFns } from "./CoFormGroup.vue?vue&type=template&id=ab16f400&"
import script from "./CoFormGroup.vue?vue&type=script&lang=ts&"
export * from "./CoFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports